<template>
    <div class="vx-flex vx-flex-col">
        <page-header>
            Campaigns

            <template v-slot:actions v-if="!props.withoutOverview">
                <vx-button
                    @click="showOverview = !showOverview"
                    data-test="toggle-overview"
                    type="button"
                    color="muted-dark"
                    size="lg"
                >
                    <span class="vx-hidden sm:vx-inline-block"
                        >{{ showOverview ? "Hide" : "Show" }} Overview</span
                    >
                    <font-awesome-icon
                        class="vx-hidden sm:vx-inline-block"
                        :icon="faQuestionCircle"
                    ></font-awesome-icon>
                    <font-awesome-icon
                        class="vx-inline-block sm:vx-hidden"
                        :icon="
                            showOverview
                                ? faCircleChevronUp
                                : faCircleChevronDown
                        "
                    ></font-awesome-icon>
                </vx-button>
            </template>
        </page-header>

        <campaign-overview v-show="showOverview"/>
    </div>
</template>
<script setup>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
    faCircleChevronDown,
    faCircleChevronUp,
    faQuestionCircle,
} from "@fortawesome/pro-solid-svg-icons";
import { VxButton } from "@voxie/frontend-components";
import { ref } from "vue";
import PageHeader from "~/components/general/PageHeader.vue";
import CampaignOverview from "./CampaignOverview.vue";

const props = defineProps({
    withoutOverview: {
        type: Boolean,
        default: false,
    },
});

const showOverview = ref(false);
</script>
